import React, { useState, useEffect, useRef } from "react";
import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Space, Spin, Table, Tooltip, Rate } from "antd";

const VendorRatings = () => {
  const { t } = useTranslation();
  const [vendorRatingData, setVendorRatingData] = useState([]);
  const ref = useRef(null);
  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dealerId, setDealerId] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);

  const loginDetials = useSelector((state) => state.loginReducer);
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
        }
      }
    }
  }, []);
  useEffect(
    (e) => {
      const input = ref.current;
      if (input) input.setSelectionRange(cursor, cursor);
    },
    [ref, vendorRatingData]
  );

  useEffect(() => {
    handleGetVendorRatingList(pageNo, pageSize);
  }, []);

  const handleGetVendorRatingList = (pageNo, pageSize) => {
    let inputData = {
      pageNumber: pageNo,
      pageSize: pageSize,
    };
    setLoading(true);
    AdminToolsDataService.GetVendorRatingList(inputData)
      .then((response) => {
        setLoading(false);
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (responseData.vendorRatingPageResponse) {
            const temp = responseData.vendorRatingPageResponse.map((x) => {
              return { ...x, isdisable: true };
            });
            setVendorRatingData(temp);
            setTotalCount(responseData.totalRecord);
          } else {
            setVendorRatingData([]);
            setTotalCount(0);
          }
        } else {
          setVendorRatingData([]);
          setTotalCount(0);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleSave = (row) => {
    let inputData = {
      id: row.id,
      vendorID: row.vendorID,
      systemRating: row.systemRating,
      manualRating: parseFloat(row.manualRating),
      dealerId: dealerId,
      ipAddress: "",
    };
    setLoading(true);
    AdminToolsDataService.SaveVendorRating(inputData)
      .then((response) => {
        setLoading(false);
        var message = response.data.message;
        if (message === "Success") {
          NotificationManager.success(t("Vendor Rating Updated Successfully."));
          handleGetVendorRatingList(pageNo, pageSize);
        } else {
          NotificationManager.success(t("Vendor Rating Not Updated ."));
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleChangeRating = (row, newRating) => {
    const temp = vendorRatingData.map((x) => {
      if (x.id === row.id) {
        return { ...x, manualRating: newRating, isdisable: false };
      } else return x;
    });

    setVendorRatingData(temp);
  };

  function handlePageNoChange(page, pageSize) {
    setPageNo(page);
    handleGetVendorRatingList(page, pageSize);
  }
  function handlePageSizeChange(current, size) {
    setPageSize(size);
    handleGetVendorRatingList(current, size);
  }

  return (
    <React.Fragment>
      <div className="vendorate_section">
        <div className="form__fields">
          <div className="row">
            <div className="col-lg-12">
              <h4 className="workarea__heading mt-0 mb-0">
                {t("Vendor Ratings")}
              </h4>
            </div>

            <div className="col-lg-12 mt-4">
              <div className="vendor_tbldiv">
                <Spin spinning={loading} size="large">
                  <Table
                    columns={[
                      {
                        dataIndex: "vendorID",
                        title: (
                          <Tooltip title={t("Vendor ID")}>
                            {t("Vendor ID")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                      },
                      {
                        dataIndex: "dealerName",
                        title: (
                          <Tooltip title={t("Vendor Name")}>
                            {t("Vendor Name")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        width: "230px",
                      },
                      {
                        dataIndex: "systemRating",
                        title: (
                          <Tooltip title={t("System Ratings")}>
                            {t("System Ratings")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                      },
                      {
                        dataIndex: "manualRating",
                        title: (
                          <Tooltip title={t("Manual Ratings")}>
                            {t("Manual Ratings")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        render: (item, row) => {
                          return (
                            <Rate
                              value={row.manualRating}
                              allowHalf
                              allowClear
                              style={{ color: '#1883b8', fontSize: '18px' }}
                              onChange={(newRating) => {
                                handleChangeRating(row, newRating);
                              }}
                            />
                          );
                        },
                        width: 140,
                      },
                      {
                        dataIndex: "dateModified",
                        title: (
                          <Tooltip title={t("Modified Date")}>
                            {t("Modified Date")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        render: (text) => text?.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'),
                      },

                      {
                        title: (
                          <Tooltip title={t("Save Vendor Rating")}>
                            {t("Save Vendor Rating")}
                          </Tooltip>
                        ),
                        ellipsis: true,
                        key: "action",
                        dataIndex: "isdisable",
                        render: (text, row) => (
                          <Space size="middle">
                            <button
                              className={
                                row.isdisable == true
                                  ? "disabled-btn"
                                  : "primary-btn"
                              }
                              disabled={row.isdisable == true ? true : false}
                              onClick={() => {
                                handleSave(row);
                              }}
                            >
                              {t("Save")}
                            </button>
                          </Space>
                        ),
                      },
                    ]}
                    dataSource={vendorRatingData}
                    scroll={{ y: "calc(100vh - 340px)" }}
                    onChange={(pagination, filters, sorters) => {
                      var tableBody = document.querySelector(".vendor_tbldiv .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
                    }}
                    pagination={{
                      size: "small",
                      total: totalCount,
                      pageNo: pageNo,
                      pageSize: pageSize,
                      pageSizeOptions: [10, 15, 20, 50, 100],
                      responsive: true,
                      showSizeChanger: true,
                      onChange: handlePageNoChange,
                      onShowSizeChange: handlePageSizeChange,
                    }}
                  />
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default VendorRatings;
